import {OauthService} from './oauth.service';
import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Http} from '@angular/http';
import {App} from 'ionic-angular';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class CompteBancaireService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
    this.loader.next(true); // init custom loader
  }

  public getForReimbursement(activiteId: number) {
    const url = this.Routing.generate('api_get_compte-banques_remboursement', {
      '_format': 'json',
      'activiteId': activiteId
    }, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => response.json().data);
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/compteBancaire.service.ts